import { urlUtility } from "@repo/utilities/url.utility.ts";
import { TBROKERS } from "#/types/global.types";

function isPartnerFlow() {
  const isAssisted = import.meta.env.VITE_USER !== "customer";
  const urlQueries = urlUtility.getUrlQueries(window.location.href);
  const pageId = urlQueries["page-id"];
  const from = urlQueries["from"];
  const isPartner = isAssisted || (from !== "journey-links" && !!pageId);
  return isPartner;
}

function isCustomerFlow() {
  return import.meta.env.VITE_USER === "customer";
}

function detectPartner() {
  if (import.meta.env.DEV) {
    return "rupenetsol";
  }
  const isPartnerNamePresentInHost =
    location.host?.split(".").length === 4 && location.host?.split(".")?.[0];

  return isPartnerNamePresentInHost || null;
}

function isCurrentBroker(broker: TBROKERS) {
  return import.meta.env.VITE_BROKER === broker;
}

export { isPartnerFlow, isCustomerFlow, detectPartner, isCurrentBroker };
